import React, { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import { ReorderPointModalProps } from "../../common/types/inventory"
import { injectIntl } from "react-intl"
import { STOCK_DOCUMENTS_LISTING_REORDER_POINT_MESSAGES } from "../../utils/inventory"
import { CancelButton, SaveButton } from "../../common/button"
import intlProps from "../../state/helpers/IntlProps"
import InputUnitOfMeasure from "../../common/unit-of-measure/input.component"
import { useDispatch, useSelector } from "react-redux"
import { Action } from "../../state/inventory/data/actions"
import { Selector } from "../../state/product/selectors/selectors"

export const ReorderPointModal = injectIntl((props: ReorderPointModalProps & intlProps) => {
    const invData = useSelector(state => Selector.getInventoryDataFromInventoryLocationQuantities(props.dataId, state))
    const [reorderPoint, setReorderPoint] = useState(invData?.attributes.inventoryLocationQuantities.attributes.reorderPoint ?? "0")
    const [reorderQuantity, setReorderQuantity] = useState(invData?.attributes.inventoryLocationQuantities.attributes.reorderQuantity ?? "0")
    const [initialState, setInitialState] = useState({
        reorderPoint: invData?.attributes.inventoryLocationQuantities.attributes.reorderPoint ?? "0",
        reorderQuantity: invData?.attributes.inventoryLocationQuantities.attributes.reorderQuantity ?? "0"
    })

    const dispatch = useDispatch()

    const onSave = () => {
        if (!invData) {
            return
        }

        dispatch(Action.patch(invData.id, {
            inventoryLocationQuantities: {
                reorderQuantity: reorderQuantity,
                reorderPoint: reorderPoint,
            }
        }))

        setTimeout(() => {
            props.onCloseCallback()
        }, 1000)
    }

    useEffect(() => {
        setReorderPoint(invData?.attributes.inventoryLocationQuantities.attributes.reorderPoint ?? "0")
        setReorderQuantity(invData?.attributes.inventoryLocationQuantities.attributes.reorderQuantity ?? "0")
        setInitialState({
            reorderPoint: invData?.attributes.inventoryLocationQuantities.attributes.reorderPoint ?? "0",
            reorderQuantity: invData?.attributes.inventoryLocationQuantities.attributes.reorderQuantity ?? "0"
        })
    }, [
        invData?.attributes.inventoryLocationQuantities.attributes.reorderPoint,
        invData?.attributes.inventoryLocationQuantities.attributes.reorderQuantity
    ])

    const disable = reorderPoint == initialState.reorderPoint && reorderQuantity == initialState.reorderQuantity ||
        reorderPoint == "" || reorderQuantity == "" || Number(reorderQuantity) < 0

    return (
        <Modal
            show={true}
            onHide={() => props.onCloseCallback()}
            backdrop={"static"}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {props.intl.formatMessage(STOCK_DOCUMENTS_LISTING_REORDER_POINT_MESSAGES.header)}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="form-row">
                    <label
                        className="col-5 col-form-label">
                        {props.intl.formatMessage(STOCK_DOCUMENTS_LISTING_REORDER_POINT_MESSAGES.reorderPoint)}
                    </label>
                    <div className="col-5">
                        <InputUnitOfMeasure
                            onChange={val => setReorderPoint(val)}
                            value={reorderPoint}
                            debounced={true}
                            allowNegative={false}
                            disabled={false}
                            format={"short"}
                        />
                    </div>
                </div>

                <div className="form-row pt-2">
                    <label
                        className="col-5 col-form-label">
                        {props.intl.formatMessage(STOCK_DOCUMENTS_LISTING_REORDER_POINT_MESSAGES.reorderQuantity)}
                    </label>
                    <div className="col-5">
                        <InputUnitOfMeasure
                            onChange={val => Number(val) > 0 && setReorderQuantity(val)}
                            value={reorderQuantity}
                            debounced={true}
                            allowNegative={false}
                            disabled={false}
                            format={"short"}
                        />
                    </div>
                </div>

            </Modal.Body>

            <Modal.Footer>
                <CancelButton onClickCallback={props.onCloseCallback}/>
                <SaveButton disabled={disable} onClickCallback={onSave}/>
            </Modal.Footer>
        </Modal>
    )
})


// WEBPACK FOOTER //
// ./src/inventory/modals/ReorderPointModal.tsx